import { Button, Grid2, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import { useEffect, useState } from "react";
import { Label } from "flowbite-react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
var constants = require('../../constant');

const ScheduleRideSettings = () =>{
    const [isActive, setIsActive] = useState(true);
    const [scheduleAlarmTime, setScheduleAlarmTime] = useState('');
    const [scheduleCurrTimeDiff, setScheduleCurrTimeDiff] = useState('');
    const [scheduleDaysLimit, setScheduleDaysLimit] = useState('');
    const [scheduleRidesLimit, setScheduleRidesLimit] = useState('');
    const [scheduleCancelWindow, setScheduleCancelWindow] = useState('');
    const [dispatchType, setDispatchType] = useState('1');
    const [delayedTimeThreshold, setDelayedTimeThreshold] = useState('');
    const [delayedTimeThreshold2, setDelayedTimeThreshold2] = useState('');
    const [delayedTimeThreshold3, setDelayedTimeThreshold3] = useState('');
    const [rideOffsetLimit, setrideOffsetLimit] = useState('');
    const [noShowCutOffTime, setNoShowCutOffTime] = useState('');
    const [noShowCutPercentage, setNoShowCutPercentage] = useState('');
    const [noShowTaxPercentage, setNoShowTaxPercentage] = useState('');

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [dataa, setDataa] = useState([]);
    const [scheduleId, setScheduleId] = useState(0);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const clientId = localStorage.getItem('clientId');

    const fetchScheduleRideSettings = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/schedule_ride';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // setDataa(response.data);
                const fetchedData = response.data[0];
                setScheduleAlarmTime(fetchedData.alarm_time);
                setScheduleCurrTimeDiff(fetchedData.current_time_diff);
                setScheduleDaysLimit(fetchedData.days_limit);
                setScheduleRidesLimit(fetchedData.rides_limit);
                setScheduleCancelWindow(fetchedData.cancel_window);
                setDispatchType(fetchedData.dispatch_type);
                setScheduleId(fetchedData.id);
                setDelayedTimeThreshold(fetchedData.delayed_time_threshold);
                setDelayedTimeThreshold2(fetchedData.delayed_time_threshold_2);
                setDelayedTimeThreshold3(fetchedData.delayed_time_threshold_3);
                setrideOffsetLimit(fetchedData.ride_offset_minutes);
                setIsActive(fetchedData.is_active==0 ? false : true);
                setNoShowCutOffTime(fetchedData.no_show_cutoff_time);
                setNoShowCutPercentage(fetchedData.no_show_cut_percentage);
                setNoShowTaxPercentage(fetchedData.no_show_tax_percentage);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchScheduleRideSettings();
    },[])

    const saveData = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            dispatch_type: dispatchType,
            is_active: isActive==true ? 1 : 0,
        };
        if(scheduleAlarmTime!=""){
            payload.alarm_time = scheduleAlarmTime;
        }
        if(scheduleCancelWindow!=""){
            payload.cancel_window = scheduleCancelWindow;
        }
        if(scheduleCurrTimeDiff!=""){
            payload.current_time_diff = scheduleCurrTimeDiff;
        }
        if(scheduleDaysLimit!=""){
            payload.days_limit = scheduleDaysLimit;
        }
        if(scheduleRidesLimit!=""){
            payload.rides_limit = scheduleRidesLimit;
        }
        if(rideOffsetLimit!="" && dispatchType!=1){
            payload.ride_offset_minutes = rideOffsetLimit;
        }
        if(scheduleId!=0){
            payload.id = scheduleId;
        }
        if(delayedTimeThreshold && dispatchType!=1){
            payload.delayed_time_threshold = delayedTimeThreshold;
        }
        if (dispatchType != 1 && clientId == 188) {
            const t1 = Number(delayedTimeThreshold);
            const t2 = Number(delayedTimeThreshold2);
            const t3 = Number(delayedTimeThreshold3);

            if (t1 < 0 || t1 > 180) {
                setMessage("Threshold 1 must be between 0 and 180");
                showSnackbar(true);
                return;
            }

            if (delayedTimeThreshold2 !== '') {
                if (t2 < 0 || t2 > 180) {
                    setMessage("Threshold 2 must be between 0 and 180");
                    showSnackbar(true);
                    return;
                }

                if (t2 <= t1) {
                    setMessage("Threshold 2 must be greater than Threshold 1");
                    showSnackbar(true);
                    return;
                }
            }

            if (delayedTimeThreshold3 !== '') {
                if (t3 < 0 || t3 > 180) {
                    setMessage("Threshold 3 must be between 0 and 180");
                    showSnackbar(true);
                    return;
                }

                if (t3 <= t2) {
                    setMessage("Threshold 3 must be greater than Threshold 2");
                    showSnackbar(true);
                    return;
                }
            }

            payload.delayed_time_threshold_2 = delayedTimeThreshold2;
            payload.delayed_time_threshold_3 = delayedTimeThreshold3;
        }
        if(noShowCutOffTime!=""){
            payload.no_show_cutoff_time = noShowCutOffTime;
        }
        if(noShowCutPercentage!=""){
            payload.no_show_cut_percentage = noShowCutPercentage;
        }
        if(noShowTaxPercentage!=""){
            payload.no_show_tax_percentage = noShowTaxPercentage;
        }

        try {
            const url = operationsUrl + '/schedule/add_update_schedule_ride_setting';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleNonNegative = (setter) => (e) => {
        const value = e.target.value;
        if (value === '') {
            setter('');
            return;
        }
        const n = Number(value);
        if (Number.isNaN(n)) {
            return;
        }
        setter(n < 0 ? String(Math.abs(n)) : value);
    };

    // Shared handlers to prevent negative input in number fields
    const preventNegativeKey = (e) => {
        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
            e.preventDefault();
        }
    };

    return(
        <div> 
            {tokenExpired && (<TokenError/>)}
            {/* <Navbar/>
            <div className='App'>
                <Sidemenu/>
                <div className='content'> */}
                    <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Setting</Typography>

                    <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>
                        <Typography sx={{color:'#4E545D', fontSize:'24px'}}>Schedule Ride Setting</Typography>
                        <Grid2 container item sx={{border:'1px solid #D1D5DB', marginTop:'18px', borderRadius:'12px', padding:'6px 12px', alignItems:'center'}}>
                            <Grid2 item ><Typography>Schedule Ride</Typography></Grid2>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button
                                    variant="contained" onClick={() => setIsActive(true)} 
                                    style={{ backgroundColor: isActive ? '#0DBA78' : '#F4F4F4', color: isActive ? '#FFFFFF' : '#9E9E9E',textTransform: 'none',
                                        borderRadius: '8px 0 0 8px',boxShadow: 'none',padding: '6px 16px',minWidth: '80px'}}>
                                    Enable
                                </Button>
                                <Button
                                    variant="contained" onClick={() => setIsActive(false)} 
                                    style={{backgroundColor: !isActive ? '#D14545' : '#F4F4F4',color: !isActive ? '#FFFFFF' : '#9E9E9E',
                                        textTransform: 'none',borderRadius: '0 8px 8px 0',boxShadow: 'none',padding: '6px 16px', minWidth: '80px',
                                    }}>
                                    Disable
                                </Button>
                            </Grid2>
                        </Grid2>

                        <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                            <Grid2 item size={6}>
                                <Label>Schedule Alarm Time (minutes)<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  
                                    sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Alarm Time" 
                                    fullWidth 
                                    variant="outlined" 
                                    type="text" 
                                    value={scheduleAlarmTime}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Convert to number for comparison
                                        const numValue = Number(value);
                                        const numDelayedThreshold = Number(delayedTimeThreshold);

                                        // Validation Logic:
                                        if (!isNaN(numValue) && (numValue === 0 || numValue > numDelayedThreshold)) {
                                            setScheduleAlarmTime(value);
                                        } else {
                                            alert(`Schedule Alarm Time must be either 0 or greater than Delayed Time Threshold (${numDelayedThreshold} minutes).`);
                                        }
                                    }}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: { height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF' }
                                    }}
                                />
                            </Grid2>

                            <Grid2 item size={6}>
                                <Label>Schedule Current Time Diff (minutes)<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Current Time Diff" fullWidth variant="outlined" type="text" 
                                    value={scheduleCurrTimeDiff}
                                    onChange={(e) => setScheduleCurrTimeDiff(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>
                        </Grid2>

                        <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                            <Grid2 item size={6}>
                                <Label>Schedule Day Limit<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Day Limit" fullWidth variant="outlined" type="text" 
                                    value={scheduleDaysLimit}
                                    onChange={(e) => setScheduleDaysLimit(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>

                            <Grid2 item size={6}>
                                <Label>Schedule Limit<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Limit" fullWidth variant="outlined" type="text" 
                                    value={scheduleRidesLimit}
                                    onChange={(e) => setScheduleRidesLimit(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>
                        </Grid2>

                        <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                            <Grid2 item size={6}>
                                <Label>Schedule Cancel Window (minutes)<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Cancel Window" fullWidth variant="outlined" type="text" 
                                    value={scheduleCancelWindow}
                                    onChange={(e) => setScheduleCancelWindow(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>
                            <Grid2 item size={6}>
                                <Label>Dispatch Type<span style={{ color: 'red' }}>*</span></Label>
                                {/* <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Dispatch Type" fullWidth variant="outlined" type="text" 
                                    value={dispatchType}
                                    onChange={(e) => setDispatchType(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                /> */}
                                <Select sx={{marginTop:'2%'}}
                                    value={dispatchType} fullWidth
                                    onChange={(e) => {
                                        setDispatchType( e.target.value)
                                        if(e.target.value==1){
                                            setDelayedTimeThreshold(0);
                                            setrideOffsetLimit(0);
                                        }
                                    }}
                                    style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                    
                                    {Object.entries(constants.dispatchTypeConst).map(([id, label]) => (
                                        <MenuItem key={id} value={id}>
                                            {label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>
                        </Grid2>

                        {dispatchType!=1 && (
                            <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                                <Grid2 item size={6}>
                                    <Label>Delayed Time Threshold (0 - 180 minutes)<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                        placeholder="Delayed Time Threshold" fullWidth variant="outlined" type="text" 
                                        value={delayedTimeThreshold}
                                        // onChange={(e) => setDelayedTimeThreshold(e.target.value)}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (!isNaN(value) && Number(value) >= 0 && Number(value) <= 180) {
                                                setDelayedTimeThreshold(value);
                                            } else if (Number(value) > 180) {
                                                alert('You cannot enter a value greater than 180 minutes.');
                                            } else if (value === '') {
                                                setDelayedTimeThreshold('');
                                            }
                                        }}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                </Grid2>

                                <Grid2 item size={6}>
                                    <Label>Ride Offset Limit (minutes)<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                        placeholder="Ride Offset Limit" fullWidth variant="outlined" type="text" 
                                        value={rideOffsetLimit}
                                        onChange={(e) => setrideOffsetLimit(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                </Grid2>
                            </Grid2>
                        )}

                        {(clientId==188) && (dispatchType!=1) && (
                            <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                                <Grid2 item size={6}>
                                    <Label>Delayed Time Threshold 2 (0 - 180 minutes)</Label>
                                    <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                        placeholder="Delayed Time Threshold" fullWidth variant="outlined" type="text" 
                                        value={delayedTimeThreshold2}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            if (value === '') {
                                                setDelayedTimeThreshold2('');
                                                return;
                                            }

                                            if (!/^\d*$/.test(value)) return; 

                                            setDelayedTimeThreshold2(value);
                                        }}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                </Grid2>
                                <Grid2 item size={6}>
                                    <Label>Delayed Time Threshold 3 (0 - 180 minutes)</Label>
                                    <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                        placeholder="Delayed Time Threshold" fullWidth variant="outlined" type="text" 
                                        value={delayedTimeThreshold3}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            if (value === '') {
                                                setDelayedTimeThreshold3('');
                                                return;
                                            }

                                            if (!/^\d*$/.test(value)) return;

                                            setDelayedTimeThreshold3(value);
                                        }}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                </Grid2>
                            </Grid2>
                        )}

                        {(clientId==192) && //primekar - jatty
                            <>
                                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                                    <Grid2 item size={6}>
                                        <Label>No Show Cut Percentage<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                            placeholder="No Show Cut Percentage" fullWidth variant="outlined" type="number" 
                                            value={noShowCutPercentage}
                                            onChange={handleNonNegative(setNoShowCutPercentage)}
                                            onKeyDown={preventNegativeKey}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item size={6}>
                                        <Label>No Show Cutoff Time (in minutes)<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                            placeholder="No Show Cutoff Time" fullWidth variant="outlined" type="number" 
                                            value={noShowCutOffTime}
                                            onChange={handleNonNegative(setNoShowCutOffTime)}
                                            onKeyDown={preventNegativeKey}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>
                                </Grid2>

                                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                                    <Grid2 item size={6}>
                                        <Label>No Show Tax Percentage<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                            placeholder="No Show Tax Percentage" fullWidth variant="outlined" type="number" 
                                            value={noShowTaxPercentage}
                                            onChange={handleNonNegative(setNoShowTaxPercentage)}
                                            onKeyDown={preventNegativeKey}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>
                                </Grid2>
                            </>
                        }

                        <Grid2 item sx={{marginTop:'24px', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'24px'}} size={12}>
                            
                                <Button onClick={saveData} variant="contained">Update</Button>
                            
                        </Grid2>
                    </Grid2>

                    <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

                {/* </div>
            </div> */}
        </div>
    )
}

export default ScheduleRideSettings;